import './styles/CategoryCard.scss';

import { Delete, Edit, MoreVert } from '@mui/icons-material';
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import { Category } from '@thro-types/leihbar';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  category: Category;
  handleEditClick: (category: Category) => void;
  handleDeleteClick: (category: Category) => void;
}

const CategoryCard = (props: Props) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleSettingsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
  };
  const handleSettingsMenuClose = (event: React.MouseEvent) => {
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Card>
      <CardContent>
        <Grid container className="categorycard__container">
          <Grid item xs={9}>
            <Typography className="categorycard__name">{props.category.name}</Typography>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              aria-label="settings"
              onClick={e => {
                handleSettingsMenuClick(e);
              }}
            >
              <MoreVert />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleSettingsMenuClose}
              className="event-card__menu"
            >
              <MenuItem
                onClick={e => {
                  props.handleEditClick(props.category);
                  handleSettingsMenuClose(e);
                }}
              >
                <ListItemIcon>
                  <Edit sx={{ color: 'lightblue' }} />
                </ListItemIcon>
                <ListItemText>{t(translations.common.edit())}</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={e => {
                  props.handleDeleteClick(props.category);
                  handleSettingsMenuClose(e);
                }}
              >
                <ListItemIcon>
                  <Delete sx={{ color: 'red' }} />
                </ListItemIcon>
                <ListItemText>{t(translations.common.delete())}</ListItemText>
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CategoryCard;
